module.exports = __webpack_public_path__ + "img/heibaimochoubiandaiWu.min.09158632.png";